const SelectedMenuSessionVariable = "SelectedMenuItem";

export default SelectedMenuSessionVariable;
